import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { SupermarketAisleDto } from '@bemum/api-interfaces';

@Injectable({
  providedIn: 'root',
})
export class SupermarketAisleService {
  constructor(private http: HttpClient) {}

  getList() {
    return this.http.get<SupermarketAisleDto[]>(`${environment.api_url}/supermarketAisles`);
  }
}
